"use strict";
import fetch from "@elements/fetch";
import initModulesInScope from '@elements/init-modules-in-scope';

export function initInScope($scope) {
    $scope.find('.js-address-validation').each(function () {
        let $baseElement = $(this);
        let $submitButton = $baseElement.find('.js-address-validation__submit-btn');
        let $collapseButton = $baseElement.find('.js-address-validation__collapse-btn');
        let $modal = $baseElement.find('.js-address-validation__modal');
        let $modalContent = $modal.find('.js-address-validation__modal-content');

        $collapseButton.on('validate-address', async function(e) {
            await buttonClickHandler($baseElement, $modal, $modalContent, false);
            $collapseButton.trigger('validated-successfully');
        });

        $submitButton.on('click', async function() {
            let $form = $baseElement.find('.js-address-validation__form');

            if ($form.parsley().validate()) {
                let hasError = await buttonClickHandler($baseElement, $modal, $modalContent, true);
                if (!hasError) {
                    $form.submit();
                }
            }
        });
    });
}

async function buttonClickHandler($baseElement, $modal, $modalContent, isSubmitBtn) {
    let requests = [];
    let loadingSpinners = [];
    let errors = [];
    let allGroupInputs = [];

    $baseElement.find('.js-address-validation__group').each(function () {
        let $group = $(this);

        if ($group.hasClass('collapse') && !$group.hasClass('show')) {
            return;
        }

        let $inputs = $group.find('.js-address-validation__input');
        let values = {};

        loadingSpinners.push($group.find('.js-address-validation__loading'));
        errors.push($group.find('.js-address-validation__error'));
        allGroupInputs.push($inputs);

        $inputs.each(function () {
            values[$(this).data('address-validation-input-name')] = $(this).val();
        });

        requests.push(
            fetch($baseElement.data('address-validation-url'), {
                method: 'post',
                body: new URLSearchParams({
                    postCode: values.postCode,
                    cityName: values.cityName,
                    streetName: values.streetName,
                    houseNumber: values.houseNumber
                })
            })
        );
    });

   return await handleFetchRequestsSequentially(requests, loadingSpinners, errors, $modal, $modalContent, allGroupInputs);
}

async function handleFetchRequestsSequentially(requests, loadingSpinners, errors, $modal, $modalContent, allGroupInputs) {
    let hasError = false;
    for (let i = 0; i < requests.length; i++) {
        loadingSpinners[i].attr('hidden', null);
        const fetchInfo = await handleFetchRequest(requests[i], loadingSpinners[i], errors[i], $modal, $modalContent, allGroupInputs[i]);
        hasError = !fetchInfo.success;
        if (fetchInfo.showModal) {
            await waitForModalToClose($modal);
        }
    }
    return hasError;
}

function waitForModalToClose($modal) {
    return new Promise((resolve) => {
        $modal.on('hidden.bs.modal', function() {
            resolve();
        });
    });
}

function handleFetchRequest(request, $loadingSpinner, $error, $modal, $modalContent, $inputs) {
    return request.then(function(response) {
        return response.json()
    }).then(function(result) {
        if (result.success) {
            $error.attr('hidden', 'hidden');
            let content = result.content;
            if (content && content !== '' && $modal.length > 0 && $modalContent.length > 0) {
                $modalContent.empty().append(content);
                initModulesInScope($modal);
                $modal.removeAttr('aria-hidden');
                $modal.modal('show');

                let $suggestionBtn = $modal.find('.js-address-validation__suggestion-btn');
                $suggestionBtn.on('click', function() { handleSuggestionBtnClick($suggestionBtn, $modal, $inputs); });
                return {success: true, showModal: true};
            }
            return {success: true, showModal: false};
        } else {
            $error.attr('hidden', null);
        }
    }).catch(function(e) {
        console.warn(e);
        $error.attr('hidden', null);
        return {success: false, showModal: false};
    }).finally(function() {
        $loadingSpinner.attr('hidden', 'hidden');
    });
}

function handleSuggestionBtnClick($suggestionBtn, $modal, $inputs) {
    const suggestionValues = {
        postCode: $suggestionBtn.data('address-validation-suggestion-postcode'),
        cityName: $suggestionBtn.data('address-validation-suggestion-cityname'),
        streetName: $suggestionBtn.data('address-validation-suggestion-streetname'),
        houseNumber: $suggestionBtn.data('address-validation-suggestion-housenumber')
    }
    Object.entries(suggestionValues).forEach(function([key, value]) {
        $inputs.filter('[data-address-validation-input-name="' + key + '"]').val(value);
    });
    $modal.modal('hide');
    $modal.attr('aria-hidden', 'true');
}